<div id="webcamaccessnotificationdiv" #webcamAccessNotificationDiv>
    Proctor needs access to your webcam and microphone
</div>
